/* eslint-disable prettier/prettier */
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

// ✅ TYPE (like delivery form)
interface IEncompassForm {
  _rowId?: string;
  name: string;
  value: string;
}

// ✅ SCHEMA
const schema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  value: Yup.string().required("Value is required"),
});

const EncompassConfigForm = ({
  mode,
  data,
  packageData,
  onSave,
  onCancel,
}: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IEncompassForm>({
    resolver: yupResolver(schema),
    mode: "all",
    defaultValues: {
      name: "",
      value: "",
      ...data,
    },
  });

  // ✅ Submit
  const onSubmit = (form: IEncompassForm) => {
    let updated = [...(packageData.encompassUpdateConfiguration || [])];

    if (mode === "edit") {
      updated = updated.map((d: any) => (d._rowId === form._rowId ? form : d));
    } else {
      updated.push({
        ...form,
        _rowId: `enc-${Date.now()}`,
      });
    }

    onSave(updated);
  };

  return (
    <div>
      <h2 className="pb-3 text-xl font-medium">
        {mode === "edit" ? "Edit Encompass Config" : "Add Encompass Config"}
      </h2>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col gap-4">
          {/* Name */}
          <div>
            <InputText
              placeholder="Enter Name"
              {...register("name")}
              className="w-full"
            />
            <div className="text-xs text-red-900">{errors.name?.message}</div>
          </div>

          {/* Value */}
          <div>
            <InputText
              placeholder="Enter Value"
              {...register("value")}
              className="w-full"
            />
            <div className="text-xs text-red-900">{errors.value?.message}</div>
          </div>
        </div>

        {/* Actions */}
        <div className="mt-6 flex flex-row-reverse">
          <Button
            type="submit"
            label="Save"
            icon="pi pi-check"
            className="p-button-sm p-button-success p-button-outlined"
          />
          <div className="mx-2" />
          <Button
            type="button"
            label="Cancel"
            icon="pi pi-times"
            onClick={onCancel}
            className="p-button-sm p-button-danger p-button-outlined"
          />
        </div>
      </form>
    </div>
  );
};

export default EncompassConfigForm;
